import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { InboxService } from '../../../core/src/lib/inbox.service';

@Injectable({
  providedIn: 'root',
})
export class WebChatAccessGuard {
  constructor(readonly inboxService: InboxService) {}

  canActivateChild(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.inboxService.canAccessWebChatSettings$;
  }
}
